import type { Locale } from "../i18n";

interface PolishContent {
  readonly shopIntro: string;
  readonly browse: string;
  readonly roomIdeas: string;
  readonly results: string;
  readonly allProducts: string;
  readonly clearSearch: string;
  readonly categoryNavigation: string;
  readonly noMatches: string;
}

export const polishContent: Record<Locale, PolishContent> = {
  ko: {
    shopIntro: "가구 하나, 작은 조명 하나부터. 나의 일상과 잘 어울리는 물건을 찾아보세요.",
    browse: "상품 둘러보기", roomIdeas: "이런 공간은 어때요?", results: "개의 상품", allProducts: "전체 상품",
    clearSearch: "검색과 필터 초기화", categoryNavigation: "상품 카테고리", noMatches: "조건에 맞는 상품이 없습니다. 다른 검색어나 카테고리를 선택해 보세요."
  },
  th: {
    shopIntro: "เริ่มจากเฟอร์นิเจอร์สักชิ้นหรือโคมไฟดวงเล็ก เลือกของที่เข้ากับชีวิตในแบบของคุณ",
    browse: "เลือกดูสินค้า", roomIdeas: "ไอเดียสำหรับพื้นที่ของคุณ", results: "รายการ", allProducts: "สินค้าทั้งหมด",
    clearSearch: "ล้างคำค้นและตัวกรอง", categoryNavigation: "หมวดหมู่สินค้า", noMatches: "ไม่พบสินค้าที่ตรงกัน ลองเปลี่ยนคำค้นหรือหมวดหมู่"
  },
  en: {
    shopIntro: "A piece of furniture. A little light. Find the things that feel at home in your everyday life.",
    browse: "Browse products", roomIdeas: "Picture your space", results: "products", allProducts: "All products",
    clearSearch: "Clear search and filters", categoryNavigation: "Product categories", noMatches: "No matching products. Try a different search or category."
  },
  es: {
    shopIntro: "Un mueble, una pequeña lámpara. Encuentra las piezas que encajan con tu día a día.",
    browse: "Ver productos", roomIdeas: "Imagina tu espacio", results: "productos", allProducts: "Todos los productos",
    clearSearch: "Borrar búsqueda y filtros", categoryNavigation: "Categorías de productos", noMatches: "No hay productos que coincidan. Prueba otra búsqueda o categoría."
  },
  ja: {
    shopIntro: "家具ひとつ、小さな照明ひとつから。日々の暮らしに似合うものを見つけましょう。",
    browse: "商品を見る", roomIdeas: "こんな空間はいかがですか", results: "件の商品", allProducts: "すべての商品",
    clearSearch: "検索と絞り込みをリセット", categoryNavigation: "商品カテゴリー", noMatches: "条件に合う商品がありません。検索語やカテゴリーを変えてお試しください。"
  },
  zh: {
    shopIntro: "从一件家具、一盏小灯开始，寻找适合日常生活的好物。",
    browse: "浏览商品", roomIdeas: "想象你的理想空间", results: "件商品", allProducts: "全部商品",
    clearSearch: "清除搜索与筛选", categoryNavigation: "商品分类", noMatches: "未找到符合条件的商品，请更换关键词或分类。"
  }
};
